import { ICndnFreeForm } from '@/interfaces/cndnFreeForm';
import React from 'react';
import { getFullAddress } from '@/utils/customerUtils';
import { ECndnType } from '@/enums/ECndn';
import { formatThaiDate } from '@/utils/dataUtils';
import { getShippingFullAddress } from '@/utils/shippingAddressUtils';

interface IProps {
  cndn: ICndnFreeForm;
}

const TemplateCndnFreeFormInfo = ({ cndn }: IProps) => {
  return (
    <div>
      <div className="flex flex-row gap-5 mb-2">
        <div className="basis-1/2">
          <p className="font-bold mb-1 bg-gray-300 text-black px-1 inline-block">
            BILL TO
          </p>
          <span className="text-xs"> (ขายให้)</span>
          <p className="font-bold text-xs">{cndn?.customer?.name || '-'}</p>
          <p className="text-xs max-w-[250px]">
            {getFullAddress(cndn?.customer) || '-'}
          </p>
          <p className="max-w-[250px] text-xs">
            Tel.: {cndn?.customer?.phoneNumber || '-'}
          </p>
          <p className="max-w-[250px] text-xs">
            Tax ID: {cndn?.customer?.taxId || '-'}
          </p>
          <p className="max-w-[250px] text-xs">
            Branch: {cndn?.customer?.branchId || '-'}
          </p>
        </div>
        <div className="basis-1/2">
          <p className="font-bold mb-1 bg-gray-300 text-black, px-1 inline-block">
            SHIP TO
          </p>
          <span className="text-xs"> (สถานที่จัดส่งสินค้า)</span>
          <p className="font-bold text-xs">{cndn?.shippingAddress?.name}</p>
          <p className="max-w-[250px] text-xs">
            {getShippingFullAddress(cndn?.shippingAddress) || ''}
          </p>
          <p className="max-w-[250px] text-xs  mt-3">
            Contact Name: {cndn?.shippingAddress?.contactName || '-'}
          </p>
          <p className="max-w-[250px] text-xs">
            Tel.: {cndn?.shippingAddress?.phoneNumber || '-'}
          </p>
        </div>
        <div className="basis-1/3 text-xs">
          <div className="flex flex-row justify-between mb-0.5">
            <div className="font-bold">{`${cndn?.type == ECndnType.CREDIT ? 'Credit Note' : 'Debit Note'} No.`}</div>
            <div>{cndn?.code || '-'}</div>
          </div>
          <div className="flex flex-row justify-between text-xs mb-2">
            <div className="font-bold">DATE </div>
            <div>{formatThaiDate(cndn?.docDate)}</div>
          </div>
          <div className="flex flex-row justify-between  mb-0.5">
            <div className="font-bold">Div.</div>
            <div>{cndn?.businessUnitName || ''}</div>
          </div>
          <div className="flex flex-row justify-between  mb-0.5">
            <div className="font-bold">Cust. </div>
            <div>{cndn?.customer?.code || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateCndnFreeFormInfo;
